import { useEffect } from "react";

export default function usePageMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} · Thrive Bridge Mental Wellness CIC`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
